'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _date = require('@marmalade/date');
var _atLeastAge = require('@marmalade/validation/lib/at-least-age');
var _atLeastAge2 = _interopRequireDefault(_atLeastAge);
var _atMostAge = require('@marmalade/validation/lib/at-most-age');
var _atMostAge2 = _interopRequireDefault(_atMostAge);
var _employment = require('@marmalade/validation/lib/bundles/employment');
var _employment2 = _interopRequireDefault(_employment);
var _name = require('@marmalade/validation/lib/bundles/name');
var _name2 = _interopRequireDefault(_name);
var _inNoMoreThanDays = require('@marmalade/validation/lib/in-no-more-than-days');
var _inNoMoreThanDays2 = _interopRequireDefault(_inNoMoreThanDays);
var _notBefore = require('@marmalade/validation/lib/not-before');
var _notBefore2 = _interopRequireDefault(_notBefore);
var _oneByOne = require('@marmalade/validation/lib/one-by-one');
var _oneByOne2 = _interopRequireDefault(_oneByOne);
var _validDate = require('@marmalade/validation/lib/valid-date');
var _validDate2 = _interopRequireDefault(_validDate);
var _constants = require('../../constants');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
exports.default = function (titleOptions, employmentOptions) {
  return Object.assign({}, (0, _employment2.default)(employmentOptions), (0, _name2.default)(titleOptions), {
    dateOfBirth: (0, _oneByOne2.default)((0, _validDate2.default)(), function (value, values) {
      var now = new Date();
      now.setDate(now.getDate() + 30);
      return (0, _atLeastAge2.default)(_constants.age.min, 'You must be within 30 days of your ' + _constants.age.min + 'th birthday', {}, now)(value, values);
    }, (0, _atMostAge2.default)(_constants.age.max, 'You must be under ' + (_constants.age.max + 1) + ' to take out our learner driver insurance policy')),
    licenceStartDate: (0, _oneByOne2.default)((0, _validDate2.default)(), (0, _inNoMoreThanDays2.default)(30, 'Select a date within 30 days'), function (value, values) {
      var dob = [].concat(_toConsumableArray(values.dateOfBirth));
      dob[2] = ~~dob[2] + 16;
      var sixteenthBirthday = (0, _date.arrayToDate)(dob);
      return (0, _notBefore2.default)(sixteenthBirthday, 'Provisional licences cannot be obtained before 16 years of age')(value, values);
    })
  });
};